import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import GridTablePlainHeader from './header';
import GridTablePlainBody from './body';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  table: {
    display: 'grid',
  },
  loadMoreWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: spacing(4),
    width: '100%',
  },
  loadMoreButton: {
    border: `1px solid ${primary.bluish3}`,
    borderRadius: 44,
    color: primary.bluish4,
    lineHeight: '24px',
    justifySelf: 'center',
    padding: spacing(1, 4),
    maxHeight: 32,
  },
}));

const GridTablePlain = ({
  className = null,
  customHeaderClass = null,
  translations = {},
  headers,
  rows = [],
  preHeaderActions = [],
  headerActions = [],
  hasLoadMore = false,
  prepareDetailsUrl,
  onLoadMore = () => {},
}) => {
  const classes = useStyles();
  const headerItems = [...preHeaderActions, ...headers, ...headerActions];

  return (
    <div className={classNames(classes.table, className)}>
      <GridTablePlainHeader
        customHeaderClass={customHeaderClass}
        headers={headerItems}
      />
      <GridTablePlainBody
        headers={headerItems}
        rows={rows}
        prepareDetailsUrl={prepareDetailsUrl}
      />
      <Fade in={hasLoadMore} unmountOnExit>
        <div className={classes.loadMoreWrapper}>
          <CustomButton
            type="addWithTextRounded"
            className={classes.loadMoreButton}
            onClick={onLoadMore}
          >
            {translations.loadMore}
          </CustomButton>
        </div>
      </Fade>
    </div>
  );
};

GridTablePlain.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.shape({}),
  customHeaderClass: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.object),
  preHeaderActions: PropTypes.arrayOf(PropTypes.shape({})),
  headerActions: PropTypes.arrayOf(PropTypes.shape({})),
  hasLoadMore: PropTypes.bool,
  prepareDetailsUrl: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func,
};

export default GridTablePlain;
